import React, { useEffect } from 'react';
import { cn } from '../helpers/cn';

interface ToastProps {
  message: string;
  type?: 'success' | 'error';
  onClose: () => void;
  duration?: number;
}

export const Toast: React.FC<ToastProps> = ({
  message,
  type = 'success',
  onClose,
  duration = 3000,
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div className="fixed top-4 left-1/2 z-50 animate-fade-in-down">
      <div
        className={cn(
          'px-6 py-3 rounded-lg shadow-lg text-sm font-medium',
          type === 'success' && 'bg-green-600 text-white',
          type === 'error' && 'bg-red-600 text-white'
        )}
      >
        {message}
      </div>
    </div>
  );
};
